const theme: 'light' = 'light';

interface IColors {
  azulClaro: string;
  azulEscuro: string;
  cinzaEscuro: string;
  cinzaClaro: string;
  branco: string;
  vermelho: string;
  gold: string;
}

export const getColors = (): IColors => {
  return {
    azulClaro: '#4CAF50 ',
    azulEscuro: '#b80d46',
    cinzaEscuro: '#616161',
    cinzaClaro: '#f1f1f166',
    branco: '#ffffff',
    vermelho: '#f1f1f1',
    gold: '#ffc439',
  };
};
